import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Popover, Card, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import Parameters from 'shared/parameters';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import { CurrencyFormatter, GetOrderTag } from 'shared/services/Utility';
import deFlag from '../../../src/img/de-icon.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';
interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
const { Option } = Select;
export default function StudentCourseContentReport(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams : any = useParams();
    const [selectedOrg, setSelectedOrg] = useState(null as any);
    const [pagination, setPagination] = useState({ page: 1, per_page: '50' } as any);
    const [total, setTotal] = useState(0);
    const [items, setItems] = useState('' as any);
    const [organizations, setOrganizations] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setlang] = useState('' as any);

    // For scorm course quiz result display
    const [isModalVisible, setIsScormModalVisible] = useState(false);

    const interactionColumns = [
  {
    title: "Question",
    dataIndex: "id",
    key: "id",
  },

  {
    title: "Latency",
    dataIndex: "latency",
    key: "latency",
  },

  {
    title: "Result",
    dataIndex: "result",
    key: "result",
  },

  {
    title: "Student Response",
    dataIndex: "student_response",
    key: "student_response",
  },

  {
    title: "Correct Response",
    key: "correct_response",

    render: (_:any, record:any) => {
      return (
        record?.correct_responses?.childArray?.[0]?.pattern || "-"
      );
    },
  },
];

    const dataSource = [
        {
        key: 1,
        id: 1,
        name: "John",
        role: "Admin",
        },
        {
        key: 2,
        id: 2,
        name: "Sarah",
        role: "Manager",
        },
        {
        key: 3,
        id: 3,
        name: "Mike",
        role: "User",
        },
    ];
    
    const refreshItems = () => {
        setFetching(true);
        API_SERVICE.fetchContentReports({
            ...pagination,
            filter_organization_id: selectedOrg,
            order: 'DESC',
            order_by: 'id',
        }, RouteParams['courseId'],RouteParams['userId']).then(({ data }) => {
            if(data?.data?.completed_contents){
                data.data.completed_contents = data.data.completed_contents.map((item: any) => {

                    if (item.type === 'scorm' && item?.quiz_score) {
                        item.quiz_score.core = JSON.parse( item.quiz_score.core );
                        item.quiz_score.interactions = JSON.parse( item.quiz_score.interactions );
                    }

                    return item;
                });
            }
            setItems(data.data);
        }).catch(e => {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }).finally(() => {
            setFetching(false);

        });
    };
    console.log('items',items);
    
    useEffect(() => {
        refreshItems();
        setlang(localStorage.getItem('language'));
    },[])
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                <div className={'list-page-wrapper'}>
                    <div className="container-fluid">
                        <div className='row mb-3'>
                            <div className='col-md-12 p-0 d-flex align-items-center'>
                                <div className='mr-4'>
                                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                </div>
                                {/* <div><h3 className='mb-0'>{t('Content Reports of')+' '+ items?.course?.title}</h3></div> */}
                                 <div><h3 className='mb-0'>{t('genDict.ContentReportsOf')+' '+ items?.course?.title}</h3></div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 p-0'>
                                <div className='bg-white p-3 br-5px'>
                                <div className="row">
                                    <div className=" col-lg-4 d-webkit-box">
                                        <div className="card w-100 card-inverse card-success">
                                        <div className="card-block h-100 d-flex align-items-center justify-content-space-between p-3 bg-purple">
                                            <div className={lang == 'ar' ? 'w-100' : ''}>
                                                <h6 className="text-uppercase text-white mb-1">{t('genDict.TotalContent')}</h6>
                                                <p className='text-white mb-1 small'>{t('genDict.TotalContentInCourse')}</p>
                                            </div>
                                            <div>
                                                <h4 className="display-6 text-white">{items?.all_contents?.length}</h4>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className=" col-lg-4 d-webkit-box">
                                        <div className="card w-100 card-inverse card-danger">
                                        <div className="card-block h-100 d-flex align-items-center justify-content-space-between  p-3 bg-blue">
                                            <div className={lang == 'ar' ? 'w-100' : ''}>
                                                <h6 className="text-uppercase text-white mb-1">{t('genDict.CompletedContent')}</h6>
                                                <p className='text-white mb-1 small'>{t('genDict.CompletedContentParagraph')}</p>
                                            </div>
                                            <div>
                                                <h4 className="display-6 text-white">{items?.completed_contents?.length}</h4>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 d-webkit-box">
                                        <div className="card w-100 card-inverse card-info">
                                        <div className="card-block h-100 d-flex align-items-center justify-content-space-between  p-3 bg-info">
                                            <div className={lang == 'ar' ? 'w-100 order-2' : ''}>
                                                <h6 className="text-uppercase text-white mb-1">{t('genDict.CompletionPercentage')}</h6>
                                                <p className='text-white mb-1 small'>{t('genDict.CompletionPercentageParagraph')}</p>
                                            </div>
                                            <div>
                                                <h4 className="display-6 text-white">{Math.round((items?.completed_contents?.length * 100)/items?.all_contents?.length)}%</h4>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className='bg-white p-3 mt-3 br-5px'>
                                <div className="row">
                                    <div className=" col-lg-4 d-webkit-box">
                                        <div className="card w-100 card-inverse card-success">
                                        <div className="card-block h-100 d-flex align-items-center justify-content-space-between p-3 bg-purple">
                                            <div className={lang == 'ar' ? 'w-100 order-2' : ''}>
                                                <h6 className="text-uppercase text-white mb-1">{t('genDict.TotalQuiz')}</h6>
                                                <p className='text-white mb-1 small'>{t('genDict.TotalQuizParagraph')}</p>
                                            </div>
                                            <div>
                                                <h4 className="display-6 text-white">{items?.all_quizes?.length}</h4>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className=" col-lg-4 d-webkit-box">
                                        <div className="card w-100 card-inverse card-danger">
                                        <div className="card-block h-100 d-flex align-items-center justify-content-space-between  p-3 bg-blue">
                                            <div className={lang == 'ar' ? 'w-100' : ''}>
                                                <h6 className="text-uppercase text-white mb-1">{t('genDict.CompletedQuiz')}</h6>
                                                <p className='text-white mb-1 small'>{t('genDict.CompletedQuizParagraph')}</p>
                                            </div>
                                            <div>
                                                <h4 className="display-6 text-white">{items?.completed_quiz_contents?.length}</h4>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 d-webkit-box">
                                        <div className="card w-100 card-inverse card-info">
                                        <div className="card-block h-100 d-flex align-items-center justify-content-space-between  p-3 bg-info">
                                            <div className={lang == 'ar' ? 'w-100 order-2' : ''}>
                                                <h6 className="text-uppercase text-white mb-1">{t('genDict.CompletionPercentage')}</h6>
                                                <p className='text-white mb-1 small'>{t('genDict.CompletionPercentageParagraph')}</p>
                                            </div>
                                            <div>
                                                <h4 className="display-6 text-white">{Math.round((items?.completed_quiz_contents?.length * 100)/items?.all_quizes?.length)}%</h4>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-8 mt-3 p-0'>
                                <div className='bg-white p-3 br-5px'>
                                    <div className="row">
                                        <div className='col-md-12'><h4>{t('genDict.QuizPerformance')}</h4></div>
                                    <div className="col-md-12 pb-3">
                                        <div className="table-responsive table-br-5 box-shadow mt-2">
                                            <table className="table  table-meetings table-report">
                                            <thead>
                                                <tr>
                                                <th className="text-uppercase text-secondary">{t('genDict.QuizTitle')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.UserScore')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.TotalScore')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.ScorePercentage')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    items?.completed_quiz_contents && items.completed_quiz_contents.map((item : any) => {
                                                        return <tr>
                                                        
                                                        <td className="text-secondary">{item?.title}</td>
                                                        <td className="text-secondary text-center">{item?.user_score}</td>
                                                        <td className="text-secondary text-center">{item?.total_score}</td>
                                                        <td className="text-secondary text-center">
                                                            <div className="circle-small mt-4">
                                                                <a type='button' onClick={() => {
                                                                    history.push(`/reports/users/${RouteParams['id']}/course/${item?.id}`)
                                                                }}>
                                                                    <div className="text">{Math.round((item?.user_score * 100)/item?.total_score)}%</div> 
                                                                    <svg>
                                                                        <circle className="bg" cx="40" cy="40" r="37"></circle>
                                                                        <circle className="progress two" cx="40" cy="40" r="37" style={{strokeDashoffset: -(((232 * ((item?.user_score * 100)/item?.total_score))/100)-232)}}></circle>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 mt-3'>
                                <div className="bg-white br-5px mb-2 p-3">
                                    <h4>{t('genDict.CourseCompletion')}</h4>
                                    <hr />
                                    <div className="pos-relative">
                                        <span className="float-left">{items?.course_completion_percentage}% {t('genDict.Completed')}</span>
							            <div className="progress" style={{background:"linear-gradient(to right, #34d399 "+`${items?.course_completion_percentage}`+"%,#efefef 0)"}}></div>
                                    </div>
                                </div>
                                <div className="bg-white br-5px p-3">
                                    <h4>{t('genDict.CompletedContents')}</h4>
                                    <hr />
                                    {
                                        items?.completed_contents &&
                                        items.completed_contents.map((item: any, index: number) => {
                                            return (
                                            <div
                                                key={index}
                                                className="bg-efefef mt-3 br-5px p-2"
                                            >
                                                {item?.type === 'scorm' && item?.scorm_score ? (
                                                <>

                                                    <div className="d-flex align-items-center justify-content-space-between">
                                                        <h6 className="mb-0">
                                                            {item?.title}
                                                             <p className="small mb-0 mt-2 text-capitalize">
                                                                {t('genDict.ContentType')}: {item?.type}
                                                            </p>
                                                        </h6>

                                                        <Button
                                                            type="link"
                                                            onClick={() => setIsScormModalVisible(true)}
                                                        >
                                                            {t('genDict.scorm.quizDetails')}
                                                        </Button>
                                                    </div>
                                                
                                                    <Modal
                                                        title={t('genDict.scorm.quizDetails')}
                                                        visible={isModalVisible}
                                                        onCancel={() => setIsScormModalVisible(false)}
                                                        footer={null}
                                                        width="80%"
                                                        destroyOnClose
                                                    >

                                                    {item?.quiz_score && item?.quiz_score?.core && (
                                                        <>
                                                            <div className="mb-2 mt-2">
                                                                <h5>Quiz Score Details</h5>
                                                            </div>
                                                            <div className="table-responsive table-br-5 box-shadow mt-2">
                                                                    <table className="table table-meetings table-report">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="text-uppercase text-secondary">
                                                                                {t('genDict.scorm.ScoreAcheived')}
                                                                            </th>

                                                                            <th className="text-uppercase text-secondary text-center">
                                                                                {t('genDict.scorm.ScormTotalScore')}
                                                                            </th>

                                                                            <th className="text-uppercase text-secondary text-center">
                                                                                {t('genDict.status')}
                                                                            </th>

                                                                            <th className="text-uppercase text-secondary text-center">
                                                                                {t('genDict.scorm.ScormAttemptCreated_at')}
                                                                            </th>

                                                                            <th className="text-uppercase text-secondary text-center">
                                                                                {t('genDict.scorm.ScormAttemptEnded_at')}
                                                                            </th>
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="">
                                                                                {item?.scorm_score?.score_raw}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item?.scorm_score?.score_max}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item?.scorm_score?.lesson_status}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item?.scorm_score?.started_at}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item?.scorm_score?.ended_at}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            
                                                        </>
                                                    )}


                                                    {item?.quiz_score?.interactions?.childArray?.length > 0 && (
                                                        <>   
                                                        
                                                            <div className="mb-2 mt-5">
                                                                <h5>{t('genDict.scorm.attemptDetails')}</h5>
                                                            </div>

                                                            <div className="table-responsive table-br-5 box-shadow mt-2">
                                                                    <table className="table table-meetings table-report">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="text-uppercase text-secondary">{t('genDict.scorm.question')}</th>
                                                                            <th className="text-uppercase text-secondary text-center">{t('genDict.scorm.time')}</th>
                                                                            <th className="text-uppercase text-secondary text-center">{t('genDict.scorm.result')}</th>
                                                                            <th className="text-uppercase text-secondary text-center">{t('genDict.scorm.studentResponse')}</th>
                                                                            <th className="text-uppercase text-secondary text-center">{t('genDict.scorm.correctResponse')}</th>   
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            item.quiz_score.interactions.childArray.map((interaction: any) => {
                                                                                return <tr>
                                                                                    <td>{interaction.id}</td>
                                                                                    <td className="text-center">{interaction.time}</td>
                                                                                    <td className="text-center">{interaction.result}</td>
                                                                                    <td className="text-center">{interaction.student_response}</td>
                                                                                    <td className="text-center">{interaction.correct_responses.childArray?.map((item: any) => item.pattern).join(", ")}</td>
                                                                                </tr>
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </>
                                                    )}
                                                        
                                                    </Modal>

                                                    <div className="mt-2">
                                                    <table className="table table-sm mb-0">
                                                        <tbody>
                                                        <tr>
                                                            <th className="p-1 text-start">
                                                            {t('genDict.scorm.ScoreAcheived')}
                                                            </th>

                                                            <td className="p-1">
                                                            <strong>
                                                                {item?.scorm_score?.score_raw}
                                                            </strong>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th className="p-1 text-start">
                                                            {t('genDict.scorm.ScormTotalScore')}
                                                            </th>

                                                            <td className="p-1">
                                                            <strong>
                                                                {item?.scorm_score?.score_max}
                                                            </strong>
                                                            </td>
                                                        </tr>
                                                        
                                                        <tr>
                                                            <th className="p-1 text-start">
                                                            {t('genDict.status')}
                                                            </th>

                                                            <td className="p-1">
                                                            <strong>
                                                                {item?.scorm_score?.lesson_status}
                                                            </strong>
                                                            </td>
                                                        </tr>                                                        

                                                        <tr>
                                                            <th className="p-1 text-start">
                                                            {t('genDict.scorm.ScormAttemptCreated_at')}
                                                            </th>

                                                            <td className="p-1">
                                                            <strong>
                                                                {item?.scorm_score?.started_at}
                                                            </strong>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th className="p-1 text-start">
                                                            {t('genDict.scorm.ScormAttemptEnded_at')}
                                                            </th>

                                                            <td className="p-1">
                                                            <strong>
                                                                {item?.scorm_score?.ended_at}
                                                            </strong>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    </div>

                                                </>
                                                ) : (
                                                <div className="">
                                                   <h6 className="mb-0">
                                                        {item?.title}
                                                    </h6>

                                                    <p className="small mb-0 text-capitalize">
                                                        {t('genDict.ContentType')}: {item?.type}
                                                    </p>
                                                </div>
                                                )}
                                            </div>
                                            );
                                        })
                                        }
                                </div>
                            </div>
                        </div>
                        </div>
                    
                </div>
                )
            }
        </AuthConsumer>
    );
}
